/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "contactus",
            "endpoint": "https://2x7n16zs77.execute-api.ap-southeast-1.amazonaws.com/credence",
            "region": "ap-southeast-1"
        }
    ]
};


export default awsmobile;
